<template>
  <div class="item">
    <div v-if="item && item.type == 'image'" class="item__image">
      <picture>
        <source
          v-if="item.image_desktop"
          :data-srcset="item.image_desktop"
          media="(min-width: 1921px)"
        />
        <source
          v-if="item.image_tablet"
          :data-srcset="item.image_tablet"
          media="(min-width: 1024px)"
        />
        <source
          v-if="item.image_mobile"
          :data-srcset="item.image_mobile"
          media="(min-width: 768px)"
        />
        <img
          v-if="item.image_thumb || item.img"
          :src="item.image_thumb || item.img"
          class="swiper-lazy"
          @click="$emit('showGallery', item.index)"
        />
      </picture>
    </div>
    <div
      v-else-if="item && item.type == 'text'"
      class="item__content d-flex justify-content-between flex-column"
    >
      <blockquote class="item__text" v-html="item.text" />
      <Person v-if="item.person" class="item__person" :person="item.person" />
    </div>
  </div>
</template>

<script>
import Person from "@/components/UI/Person.vue";
export default {
  components: {
    Person,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  emits: ["showGallery"],
};
</script>

<style scoped>
.item {
  position: relative;
  display: inline-block;
  min-width: 320px;
  max-width: 100%;
  background: #eae8e4;
}

.item:last-child {
  margin-bottom: 0;
}

.item__image {
  display: block;
  line-height: 0;
}

.item__image img {
  display: block;
  min-width: 320px;
  max-width: 100%;
  height: 400px;
  /* object-fit: contain; */
}

.item__content {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px;
}

.item__text {
  margin: 0 0 30px;
}

.item__text:last-child {
  margin-bottom: 0;
}

@media (max-width: 996px) {
  .item__image img {
    height: max-content;
  }
}
</style>
